import React, { useRef, useState } from 'react';
import { Avatar, Button, Form, Popconfirm, Space, message } from 'antd';
import { UploadOutlined, DeleteOutlined, UserOutlined } from '@ant-design/icons';
import { liveChatApi } from '../../utils/api';

const MAX_BYTES = 1024 * 1024;
const ACCEPT = '.jpg,.jpeg,.png,.webp';

/**
 * تصویر پیش‌فرض اپراتورهای بدون عکس پروفایل در ویجت سایت.
 * جدا از فرم تنظیمات ذخیره می‌شود (بارگذاری فوری).
 */
const OperatorAvatarSetting = ({ widget, onChange }) => {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(null);
  const url = widget?.default_operator_avatar_url;

  const upload = async (file) => {
    if (!file) return;
    const ext = (file.name.split('.').pop() || '').toLowerCase();
    if (!ACCEPT.split(',').includes(`.${ext}`)) {
      message.warning('فقط تصویر JPG، PNG یا WebP');
      return;
    }
    if (file.size > MAX_BYTES) {
      message.warning('حجم تصویر حداکثر ۱ مگابایت');
      return;
    }
    setLoading('upload');
    try {
      const res = await liveChatApi.uploadOperatorAvatar(file);
      if (res?.data?.widget) onChange(res.data.widget);
      message.success(res?.message || 'تصویر ذخیره شد');
    } catch (error) {
      message.error(error?.message || 'خطا در بارگذاری تصویر');
    } finally {
      setLoading(null);
    }
  };

  const remove = async () => {
    setLoading('remove');
    try {
      const res = await liveChatApi.removeOperatorAvatar();
      if (res?.data?.widget) onChange(res.data.widget);
      message.success(res?.message || 'تصویر حذف شد');
    } catch (error) {
      message.error(error?.message || 'خطا در حذف تصویر');
    } finally {
      setLoading(null);
    }
  };

  return (
    <Form.Item
      label="تصویر پیش‌فرض اپراتور"
      extra="برای اپراتورهایی که عکس پروفایل ندارند در ویجت سایت نمایش داده می‌شود. بدون تصویر، حرف اول نام اپراتور نمایش داده می‌شود. (JPG/PNG/WebP، حداکثر ۱ مگابایت، ترجیحاً مربعی)"
    >
      <Space size="middle" align="center">
        <Avatar size={56} src={url || undefined} icon={!url ? <UserOutlined /> : undefined} />
        <input
          ref={inputRef}
          type="file"
          hidden
          accept={ACCEPT}
          onChange={(e) => {
            upload(e.target.files?.[0]);
            e.target.value = '';
          }}
        />
        <Button icon={<UploadOutlined />} loading={loading === 'upload'} onClick={() => inputRef.current?.click()} style={{ fontFamily: 'CustomFont' }}>
          {url ? 'تغییر تصویر' : 'بارگذاری تصویر'}
        </Button>
        {url && (
          <Popconfirm title="تصویر پیش‌فرض حذف شود؟" okText="بله" cancelText="خیر" onConfirm={remove}>
            <Button danger icon={<DeleteOutlined />} loading={loading === 'remove'} aria-label="حذف تصویر" />
          </Popconfirm>
        )}
      </Space>
    </Form.Item>
  );
};

export default OperatorAvatarSetting;
